module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": (_vm.type + " (sin guiones)")
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 100
    }
  }, [_c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('el-input', {
    class: {
      'input-warning': _vm.id.model.length === 0
    },
    attrs: {
      "disabled": _vm.isDisabled || _vm.disabled,
      "maxlength": "11",
      "show-word-limit": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.id.model, 'id')
      }
    },
    model: {
      value: (_vm.id.model),
      callback: function($$v) {
        _vm.$set(_vm.id, "model", $$v)
      },
      expression: "id.model"
    }
  })], 1), _vm._v(" "), (_vm.id.model.length === 0) ? _c('el-alert', {
    staticClass: "message-warning-id",
    attrs: {
      "title": "Ruc Invalido",
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.disabled) ? _c('el-button', {
    staticClass: "button-id",
    attrs: {
      "id": "verificarID",
      "size": "small",
      "disabled": _vm.idLength !== 11,
      "type": _vm.buttonType
    },
    on: {
      "click": _vm.buttonClickHandler
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36191893"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AltaID.vue
// module id = 623
// module chunks = 1